<template>
    <b-link variant="link" :href="`${origin}/app/objectives/${id}`">
        {{ $t('insights.viewObjective') }}
    </b-link>
</template>

<script>
import { getOrigin } from '@/lib/url'

export default {
    name: 'ToObjective',
    props: ['id'],
    data() {
        return {
            origin: getOrigin(),
        }
    },
}
</script>
